import { useEffect } from "react";

export const useClickOutside = (
  ref: React.RefObject<HTMLElement | null>,
  onClose: () => void,
  enabled: boolean = true,
  toggleRef?: React.RefObject<HTMLElement | null>
) => {
  useEffect(() => {
    if (!enabled) return;

    const handleClick = (event: MouseEvent) => {
      // If click is on the toggle button, do nothing
      if (
        toggleRef?.current &&
        toggleRef.current.contains(event.target as Node)
      ) {
        return;
      }
      // If click is outside the dropdown, close
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onClose();
      }
    };

    // Attach the event listener when the component mounts
    document.addEventListener("mousedown", handleClick, true);

    // Clean up event listener when the component unmounts or dependencies change
    return () => {
      document.removeEventListener("mousedown", handleClick, true);
    };
  }, [ref, onClose, enabled, toggleRef]);
};
